module.exports = __webpack_public_path__ + "static/media/mini-dob.e868f156.jpg";